import { useRole } from '@ztechapps/common.hook'
import { chatPermissions } from '@ztechapps/chat.common'

export type UseCanSeeConversationsResult = { canSeeConversations: boolean }

export const useCanSeeConversations = (): UseCanSeeConversationsResult => {
  const { hasRole: canView } = useRole({ roleName: chatPermissions.canView.value })
  const { hasRole: canEdit } = useRole({ roleName: chatPermissions.canEdit.value })
  return { canSeeConversations: canView || canEdit }
}
